import { type FormikValues } from "formik";
import React, { useEffect, useState } from "react";
import KC_Heading1 from "../../../designsystem/typography/KC-Heading/KC_Heading1";
import KC_Heading2 from "../../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_UIText from "../../../designsystem/typography/KC_UIText/KC_UIText";
import "./styles.scss";

interface OnboardingContainerProps<T> {
  children: React.ReactNode | JSX.Element;
  onboardingCompletion: number;
  title: string;
  description?: string;
  bgImg: string;
  useBackground: boolean;
}

export default function OnboardingContainer<T extends FormikValues>(
  props: OnboardingContainerProps<T>
) {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentChildren, setCurrentChildren] = useState(props.children);

  useEffect(() => {
    // @ts-expect-error
    const currentType = props.children?.type?.name;
    // @ts-expect-error
    const nextType = currentChildren?.type?.name;
    const mustChange = currentType && nextType && currentType !== nextType;

    if (mustChange) {
      setIsTransitioning(true);

      const timer = setTimeout(() => {
        setCurrentChildren(props.children);
        setIsTransitioning(false);
      }, 300);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [props.children, currentChildren]);

  return (
    <>
      {props.useBackground && (
        <img
          src={props.bgImg}
          className="onboarding-bg"
          alt={"background_img"}
        />
      )}
      <div id="onboarding-container" className="onboarding-container">
        {props.title && (
          <div className="onboarding-title ml-lg-4 d-flex flex-column mt-lg-5 mb-lg-4 gap-sm">
            <KC_Heading1
              text={props.title}
              className="text-center position-relative"
            />
            <KC_Heading2
              text={props.title}
              className="display-sm text-center position-relative"
            />
            <KC_UIText
              text={props.description}
              weight="reg"
              size="medium"
              className="display-lg text-center mt-2"
            />
          </div>
        )}
        <div
          id="onboarding-children-container"
          className={`onboarding-children-container ${
            isTransitioning ? "fade-out" : "fade-in"
          }`}
        >
          {currentChildren}
        </div>
      </div>
    </>
  );
}
